module.exports = __webpack_public_path__ + "img/Z61Q_08.3d286420.jpg";